import PatientFilesIcon from '../../subparts/PatientFilesIcon';

export default PatientFilesIcon;
